module.exports = "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjE2IiB2aWV3Qm94PSIwIDAgMTYgMTYiIHdpZHRoPSIxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJtMTYyIDJ2Mmg2LjZsLTEyLjYgMTIuNiAxLjQgMS40IDEyLjYtMTIuNnY2LjZoMnYtMTB6IiBmaWxsPSIjMzMzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTU2IC0yKSIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-proceed.svg
// module id = mkWV
// module chunks = 2